<ng-container *transloco="let convert;">
  @if (isLoading) {
    <div class="loader-container">
      <app-spinner></app-spinner>
    </div>
  }
  @if (!isLoading) {
    <div class="container">
      <app-report-preview
        backLinkText="{{convert('sellModule.manageInventory.sellReportPreviewShell.backText')}}"
        backLinkRoute="../"
        [scrollPosition]="scrollPosition"
        [(selectedReportType)]="activePreviewType"
        [purchasedItemDtos]="purchasedItemDtos"
        [headerType]="headerType"
        [reportRole]="reportRole"
        [sellerRemitDtos]="sellerRemitDtos"
      ></app-report-preview>
    </div>
  }

  <app-error-modal></app-error-modal>
</ng-container>
